'use client';

import { useEffect, useRef } from 'react';
import { useDeviceStore } from '@/store/about/deviceStore';
import type { DeviceState } from '@/store/about/storeTypes';

export default function DeviceInitializer({ deviceType, clientInfo }: DeviceState) {
  const setDeviceInfo = useDeviceStore((state) => state.setDeviceInfo);
  const isInitialized = useRef(false);

  useEffect(() => {
    if (!isInitialized.current) {
      setDeviceInfo({ deviceType, clientInfo });
      isInitialized.current = true;
    }
  }, [deviceType, clientInfo, setDeviceInfo]);

  return null;
}
